import axios from "axios";
import baseURL from "../configs/api";

export const post_fileUpload = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}fileUploadData?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_fileUpload = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}fileUploadData?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_fileUpload = async (primaryKey: string, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}fileUploadData`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: { id: primaryKey, userId: userId }
    });
    return response.data;
}

export const getFileUploads = async (attributeName: string, attributeId: string, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}fileUploadData/GetFileUploadDatasByAttribute?attributeName=${attributeName}&attributeId=${attributeId}`,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
    });
    return response.data;
}